var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHealth = function SvgHealth(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34791_2510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99097 3.42859H3.42847V8.56252C3.42847 11.102 5.48715 13.1607 8.02668 13.1607C10.5662 13.1607 12.6249 11.102 12.6249 8.56252V3.42859H11.0624",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8418 13.1607V15.4595C7.8418 18.2827 10.1305 20.5714 12.9537 20.5714C15.777 20.5714 18.0657 18.2827 18.0657 15.4595V11.4029",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0713 11.4056C18.7343 11.4056 19.3701 11.1423 19.839 10.6734C20.3079 10.2046 20.5713 9.56868 20.5713 8.90564C20.5713 8.24261 20.3079 7.60673 19.839 7.13788C19.3701 6.66904 18.7343 6.40564 18.0713 6.40564C17.4083 6.40564 16.7724 6.66904 16.3036 7.13788C15.8347 7.60673 15.5713 8.24261 15.5713 8.90564C15.5713 9.56868 15.8347 10.2046 16.3036 10.6734C16.7724 11.1423 17.4083 11.4056 18.0713 11.4056Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34791_2510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHealth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "health.f1abe02a852f33849581e7015a1150ce.svg";